import { AnalyticsMeal } from '../platforms/adobe-analytics/models';

export class RemoveFromBagEvent {
  name = 'RemoveFromBagEvent';
  constructor(
    public readonly meal: AnalyticsMeal
  ){}
}
